export default {
  ht: {
    common: {
      search: "查询",
      reset: "重置",
      save: "保存",
      cancle: "取消",
      up: "上移",
      down: "下移",
      remove: "删除",
      clear: "清空",
      index: "序号",
      selected: "已选择",
      enter: "请输入",
      toSearch: "来搜索",
      customColumn: "自定义列表项",
      baseSearch: "基础搜索",
      advancedSearch: "高级搜索",
      startDate: "开始日期",
      endDate: "结束日期",
      comfirm: "确定",
      exportData: "导出数据",
      lastWeek: "最近一周",
      lastMonth: "最近一个月",
      lastThreeMonths: "最近三个月",
    },
    tree: {
      filterText: "输入关键字进行过滤",
    },
    selectLang: {
      switchLang: "切换语言",
    },
    file: {
      nopreview: "没有预览权限",
    },
  },
};
